
function DelBox() {
    return (
        <div class="modal fade flip" id="deleteOrder" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-body p-5 text-center">
              <lord-icon src="https://cdn.lordicon.com/gsqxdxog.json" trigger="loop" colors="primary:#405189,secondary:#f06548"></lord-icon>
              <div class="mt-4 text-center">
                <h4>You are about to delete ?</h4>
                <p class="text-muted fs-15 mb-4">Deleting will remove all of information from database.</p>
                <div class="hstack gap-2 justify-content-center remove">
                  <button class="btn btn-link link-success fw-medium text-decoration-none" id="deleteRecord-close" data-bs-dismiss="modal">
                    <i class="ri-close-line me-1 align-middle"></i> Close </button>
                  <button class="btn btn-danger" id="delete-record">Yes, Delete It</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
}

export default DelBox;
